import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Dialog, DialogContent } from './ui/dialog';

/**
 * Reusable modal showing an enticing description for a port, hotel,
 * group-travel type, or experience tile.
 *
 * item: { name, image, blurb, tag, ctaLabel, ctaTo, ctaState }
 */
export default function ItemDialog({ item, onClose }) {
    const navigate = useNavigate();
    if (!item) return null;
    return (
        <Dialog open={true} onOpenChange={(v) => !v && onClose()}>
            <DialogContent className="bg-brand-surface border-white/10 max-w-2xl p-0 overflow-hidden" data-testid="item-dialog">
                <div className="relative aspect-[16/9] overflow-hidden">
                    {item.image && (
                        <img src={item.image} alt={item.name} className="absolute inset-0 h-full w-full object-cover" />
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-surface via-brand-surface/30 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                        {item.tag && (
                            <div className="text-[10px] uppercase tracking-[0.3em] text-brand-aqua mb-1">{item.tag}</div>
                        )}
                        <h3 className="font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight">{item.name}</h3>
                    </div>
                </div>
                <div className="p-6 sm:p-8">
                    <p className="text-white/85 leading-relaxed text-base">{item.blurb || 'Ask Ms. Ruby for the full breakdown — every detail tailored.'}</p>
                    <div className="flex flex-wrap gap-3 mt-7">
                        <Button
                            data-testid="dialog-cta"
                            onClick={() => {
                                onClose();
                                if (item.ctaTo) {
                                    navigate(item.ctaTo, { state: item.ctaState });
                                } else {
                                    setTimeout(() => document.querySelector('[data-testid="home-lead-form"]')?.scrollIntoView({ behavior: 'smooth' }), 100);
                                }
                            }}
                            className="btn-sunset rounded-full px-6 h-11 uppercase tracking-widest font-semibold"
                        >
                            {item.ctaLabel || 'Get a Quote'}
                        </Button>
                        <Button onClick={onClose} variant="ghost" className="rounded-full px-6 h-11 uppercase tracking-widest text-white/70">
                            Keep exploring
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
